import axios from 'axios';
import store from '@/store';
import jwtToObject from '@/lib/jwt-to-object';
import { logWebHrCritical, logWebHrError } from '@/core/logger/log-wrapper';

const baseUrlOnboarding = '/onboarding';

// const baseUrl = process.env.API;
const http = axios.create({
  headers: { 'Content-Type': 'application/json' },
  crossdomain: true,
  transformRequest: [
    function (data, headers) {
      headers.common['Authorization'] = `Bearer ${store.state.token}`;
      return JSON.stringify(data);
    },
  ],
});

http.interceptors.request.use(function (config) {
  config.url = `${
    window.__APP__.SVC_API ||
    process.env.API ||
    'https://api.local.dpty.io/hr/v1'
  }${config.url}`;
  return config;
});

http.interceptors.response.use(
  (response) => {
    const token = response.headers['authorization'];
    if (token && !store.state.token && token !== store.state.token) {
      const varsOrigin = jwtToObject(store.state.token);
      const originalTenantId = varsOrigin['bid'];
      const varsTokenFromResponse = jwtToObject(token);
      const newTenantId = varsTokenFromResponse['bid'];

      logWebHrCritical({
        message: 'token mismatch from internal state and actual usage',
        metadata: {
          originalTenantId,
          newTenantId,
        },
        source: 'http',
      });
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const isTokenExpired = (token) => {
        const decodedToken = jwtToObject(token);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp < currentTime;
      };

      const tokenExpired = isTokenExpired(store.state.token);

      logWebHrError({
        message: 'there were errors with 401 status',
        metadata: {
          tenantIdFromStore: store.state.tenantId,
          isTokenExpired: tokenExpired,
        },
        source: 'http',
      });
    }

    return Promise.reject(error);
  }
);

export default http;
export { http, baseUrlOnboarding };
